module.exports = {"rechargeValueLabel":"Valor da Recarga","currency":"R$","disclaimer":"","button":"continue"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditPaymentConfirmation/data.json
// module id = 2205
// module chunks = 0